(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedproductheroblock = window.oneadvanced.refreshedproductheroblock || {};
    window.oneadvanced.refreshedproductheroblock.init = function () {
        //console.log("initializing refreshedproductheroblock js.......");

        //Below code is used to add the height for the product-hero__image class on resize
        var image = document.querySelectorAll(".product-hero__image img");
        var features = document.querySelectorAll(".product-hero__features");
        var parent = document.querySelectorAll(".product-hero__image");

        var productheroblock = document.querySelectorAll(".refreshedproductheroblock");
        var gradient = document.querySelectorAll(".product-hero__gradient");
        var producthero = document.querySelectorAll(".product-hero");

        window.addEventListener("resize", function () {
            for (var i = 0; i < image.length; i++) {
                var totalHeight = image[i].clientHeight + features[i].clientHeight;
                if (this.window.innerWidth > 639) {
                    totalHeight -= 100;
                }
                parent[i].style.height = totalHeight + "px";
            }

            for (var i = 0; i < gradient.length; i++) {
                var totalHeight = 40;
                if (producthero[i].clientHeight > gradient[i].clientHeight) {
                    totalHeight += producthero[i].clientHeight;
                }
                else {
                    totalHeight += gradient[i].clientHeight;
                }
                productheroblock[i].style.height = totalHeight + "px";
            }
        });

        window.dispatchEvent(new Event('resize'));
    };

    window.oneadvanced.refreshedproductheroblock.hasLoaded = true;
})();